const productGridData = [
  {
    id: 9001,
    image: "/images/combo_offer_jacket.png",
    title: "Combo Offer Jacket",
    price: 2899,
    description:
      "Premium combo offer jacket designed for workouts, outdoor activities and daily wear."
  },
  {
    id: 9002,
    image: "/images/rain_jacket.png",
    title: "Rain Jacket",
    price: 1549,
    description:
      "Lightweight rain jacket with water-resistant technology and comfortable fit."
  },
  {
    id: 9003,
    image: "/images/Track_pant_black.png",
    title: "Track Pant Black",
    price: 1399,
    description:
      "Breathable gym track pants ideal for running, training and casual wear."
  },
  {
    id: 9004,
    image: "/images/Track_pant_beige.png",
    title: "Track Pant Beige",
    price: 1399,
    description:
      "Comfort-fit beige track pants made with stretchable performance fabric."
  }
];

export default productGridData;